import * as staffActionCreators from 'store/actionCreators/staff';

import { staffSource } from 'sources';
import { StaffParams } from 'sources/StaffSource';
import { AppThunk } from 'store/store';
import { setError } from 'store/actions/app';

export const list = (params: StaffParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const results = await staffSource.List(params);
    dispatch(staffActionCreators.listSuccess(results));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};

export const listAll = (params: StaffParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const results = await staffSource.ListAll(params);
    dispatch(staffActionCreators.listAllSuccess(results));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};
